// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29CCB","col":"styles_col__3KAY-"};